import React from 'react';

import { useIntl } from 'react-intl';

import { IBackendCartEntries } from '@rbi-ctg/menu';
import Currency from 'components/currency';
import priceForCartEntry from 'utils/menu/price-for-cart-entry';

import { ItemName, ItemPrice, ItemQuantityBadge } from './cart-entry.styled';
import resolveEntryChild from './resolve-entry-child';

interface ICartEntry {
  entry: IBackendCartEntries;
  currencyFormatter: Function;
  index?: number;
}

const CartEntry = ({ entry, currencyFormatter, index }: ICartEntry) => {
  const { formatMessage } = useIntl();
  const row = (index ?? 0) + 1;

  return (
    <>
      <ItemQuantityBadge quantityText={formatMessage({ id: 'qty' })} row={row}>
        {entry.quantity || 1}
      </ItemQuantityBadge>
      <ItemName row={row}>
        {entry.name} {resolveEntryChild(entry, currencyFormatter)}
      </ItemName>
      <ItemPrice row={row}>
        <Currency amount={priceForCartEntry(entry)} />
      </ItemPrice>
    </>
  );
};

export default CartEntry;
